var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTechJs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Unofficial_JavaScript_logo_2 1",
    clipPath: "url(#clip0_371_125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M100 0H0V100H100V0Z",
    fill: "#F7DF1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M67.1746 78.1254C69.1889 81.4143 71.8095 83.8318 76.4445 83.8318C80.3381 83.8318 82.8254 81.8857 82.8254 79.1969C82.8254 75.9746 80.2698 74.8334 75.9841 72.9588L73.6349 71.9508C66.854 69.0619 62.3492 65.4429 62.3492 57.7921C62.3492 50.7445 67.7191 45.3794 76.1111 45.3794C82.0857 45.3794 86.381 47.4588 89.4762 52.9032L82.1587 57.6016C80.5476 54.7127 78.8095 53.5746 76.1111 53.5746C73.3587 53.5746 71.6143 55.3207 71.6143 57.6016C71.6143 60.4207 73.3603 61.5619 77.3921 63.308L79.7413 64.3143C87.7254 67.7381 92.2333 71.2286 92.2333 79.0762C92.2333 87.5365 85.5873 92.1715 76.6619 92.1715C67.9349 92.1715 62.2968 88.0127 59.5381 82.5619L67.1746 78.1254ZM33.9794 78.9397C35.4556 81.5588 36.7984 83.773 40.027 83.773C43.1143 83.773 45.0619 82.5651 45.0619 77.8683V45.9159H54.4587V77.9953C54.4587 87.7254 48.754 92.154 40.427 92.154C32.9032 92.154 28.546 88.2603 26.3302 83.5707L33.9794 78.9397Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_371_125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechJs);
export default __webpack_public_path__ + "static/media/Tech-JS.6dc34e93bc71a7d9798413a24524a4d1.svg";
export { ForwardRef as ReactComponent };